<div class="loading-background">
    <div class="loading-scene">
        <div class="loading-animation-behind"></div>
        <div class="loading-animation"></div>
        <img class="loading-logo" src="/assets/image/ikon.svg" alt="Loading" />
    </div>
</div>
